import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=64fcb3f0&"
import script from "./Cms.vue?vue&type=script&lang=js&"
export * from "./Cms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports